var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAppBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 644,
    viewBox: "0 0 375 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V644H0V0Z",
    fill: "#5070DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3735_2108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 644
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 644,
    fill: "#5070DE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3735_2108)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.75 769.4L181.028 348.896L227.366 769.4H269.75Z",
    fill: "url(#paint0_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 411.005L181.028 348.896L-97.8855 359.437V411.005Z",
    fill: "url(#paint1_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 540.914L181.028 348.896L471.388 601.369L471.388 540.914Z",
    fill: "url(#paint2_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-82.4546 769.4L181.028 348.896L-97.8855 699.681V769.4H-82.4546Z",
    fill: "url(#paint3_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 769.4V741.935L181.028 348.896L414.713 769.4H471.388Z",
    fill: "url(#paint4_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 566.364L181.028 348.896L-97.8855 512.486L-97.8855 566.364Z",
    fill: "url(#paint5_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 327.636L181.028 348.894L-97.8855 288.639V327.636Z",
    fill: "url(#paint6_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.935 769.4L181.028 348.896L69.2268 769.4H124.935Z",
    fill: "url(#paint7_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.304 769.4L181.028 348.896L300.692 769.4H361.304Z",
    fill: "url(#paint8_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 475.096L181.028 348.896L-97.8855 432.666V475.096Z",
    fill: "url(#paint9_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 464.776L181.028 348.896L471.388 512.234V464.776Z",
    fill: "url(#paint10_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0203 769.4L181.028 348.896L-43.1001 769.4H22.0203Z",
    fill: "url(#paint11_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 629.278L181.028 348.896L471.388 688.883V629.278Z",
    fill: "url(#paint12_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 654.26L181.028 348.896L-97.8855 600.298V654.26Z",
    fill: "url(#paint13_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.763 769.4L181.028 348.896L154.294 769.4H207.763Z",
    fill: "url(#paint14_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.642 -88.0469L88.8384 -88.0469L181.028 348.897L145.642 -88.0469Z",
    fill: "url(#paint15_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 301.289L181.028 348.896L471.388 341.128V301.289Z",
    fill: "url(#paint16_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 164.446L181.028 348.895L-97.8855 129.029V164.446Z",
    fill: "url(#paint17_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.813 -88.0469L181.028 348.897L471.388 -24.7708V-88.0469H454.813Z",
    fill: "url(#paint18_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 -28.6464L181.028 348.897L-61.7933 -88.0469H-97.8855V-28.6464Z",
    fill: "url(#paint19_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 122.504L181.028 348.896L471.388 178.594V122.504Z",
    fill: "url(#paint20_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 381.599L181.028 348.896L471.388 436.198V381.599Z",
    fill: "url(#paint21_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.201 -88.0469L239.314 -88.0469L181.028 348.897L297.201 -88.0469Z",
    fill: "url(#paint22_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6859 -88.0469L-6.29643 -88.0469L181.028 348.897L56.6859 -88.0469Z",
    fill: "url(#paint23_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 217.516L181.028 348.896L471.388 261.688V217.516Z",
    fill: "url(#paint24_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 258.56L181.028 348.897L-97.8855 212.973V258.56Z",
    fill: "url(#paint25_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.92 -88.0469L346.253 -88.0469L181.029 348.897L413.92 -88.0469Z",
    fill: "url(#paint26_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8855 97.4939L181.028 348.896L-97.8855 22.3125V97.4939Z",
    fill: "url(#paint27_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.388 8.91016L181.028 348.896L471.388 87.1781V8.91016Z",
    fill: "url(#paint28_radial_3735_2108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.429 -157.436L182.529 279.508L210.31 -157.436H168.429Z",
    fill: "url(#paint29_radial_3735_2108)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.947 344.036) rotate(-78.7566) scale(371.247 362.131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.934 344.004) rotate(-78.7566) scale(371.848 362.717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.009) rotate(-78.7567) scale(371.223 362.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.976 344.013) rotate(-78.7566) scale(370.513 361.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.008) rotate(-78.7567) scale(371.228 362.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.008) rotate(-78.7567) scale(371.232 362.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.538 361.311) rotate(-78.7566) scale(371.127 362.014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.969 344.012) rotate(-78.7566) scale(371.212 362.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.605 361.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.607 361.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.605 361.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.606 361.719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.605 361.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.168) rotate(90) scale(358.417 348.881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.607 361.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.009) rotate(-78.7567) scale(371.211 362.096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.809 344.61) rotate(-78.7567) scale(368.257 359.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.871 344.563) rotate(-78.7566) scale(325.493 317.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.991 344.017) rotate(-78.7567) scale(369.97 360.885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.009) rotate(-78.7567) scale(371.201 362.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.953 344.008) rotate(-78.7567) scale(371.216 362.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.497 341.233) rotate(-78.7567) scale(372.966 363.807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.936 344.006) rotate(-78.7567) scale(371.217 362.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.606 361.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.464) rotate(90) scale(371.606 361.719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 352.855) rotate(90) scale(371.594 361.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.607 361.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.464) rotate(90) scale(371.605 361.719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.034 353.465) rotate(90) scale(371.596 361.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3735_2108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.881 284.077) rotate(90) scale(282.428 274.914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppBack);
export default __webpack_public_path__ + "static/media/download-app-back.d0fedd801c26fb04fb600cbdfd6039ad.svg";
export { ForwardRef as ReactComponent };